import request from "@/utils/request.js"
// 获取产品分类
export function get_product_type(data){
  return request({
    	  method:'GET',
    	  url:'/product/get_product_type',
    	  params:data
    })
}
// 获取产品详情
export function product_read(data){
  return request({
    	  method:'GET',
    	  url:'/product/read',
    	  params:data
    })
}
